import React, { createContext, useContext, useState, useEffect } from 'react';
import { User } from 'firebase/auth';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebase/config';
import { localAuth } from '../services/localAuth';

interface AuthContextType {
  user: User | null;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType>({ user: null, loading: true });

export const useAuth = () => useContext(AuthContext);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Vérifie d'abord la session locale
    const localUser = localAuth.getCurrentUser();
    if (localUser) {
      // Crée un objet User compatible avec Firebase
      const mockUser: User = {
        uid: localUser.id,
        email: localUser.email,
        displayName: localUser.displayName,
        photoURL: null,
        phoneNumber: null,
        emailVerified: localUser.emailVerified,
        isAnonymous: false,
        providerId: 'password',
        metadata: {
          creationTime: '2024-01-01T00:00:00.000Z',
          lastSignInTime: '2024-01-01T00:00:00.000Z'
        },
        providerData: [],
        refreshToken: 'local-token',
        tenantId: null,
        delete: async () => {},
        getIdToken: async () => 'local-token',
        getIdTokenResult: async () => ({
          token: 'local-token',
          authTime: '2024-01-01T00:00:00.000Z',
          issuedAtTime: '2024-01-01T00:00:00.000Z',
          expirationTime: '2024-01-01T01:00:00.000Z',
          signInProvider: 'password',
          signInSecondFactor: null,
          claims: {}
        }),
        reload: async () => {},
        toJSON: () => ({})
      } as User;
      
      setUser(mockUser);
      setLoading(false);
      return;
    }

    // Sinon, utilise Firebase Auth
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}; 